// extracted by mini-css-extract-plugin
export default {"Ad":"GoogleAd_Ad__MX86R","card":"GoogleAd_card__yHTjc"};